// removed by extract-text-webpack-plugin
module.exports = {"keyboard_navigation_jump":"ContentArticle--keyboard_navigation_jump--1z2Di","content_article":"ContentArticle--content_article--AoN4g"};


//////////////////
// WEBPACK FOOTER
// /src/~/@healthwise/enhanced-shared-decision-point/components/ContentArticle/ContentArticle.css
// module id = 1018
// module chunks = 0